export enum Roles {
  ClientCollaborator = 'Client collaborator',
  InstitutionalContact = 'Institutional contact',
  ClientAdmin = 'Client admin',
  CooleyUser = 'Cooley user',
  RespondentDelegate = 'Respondent delegate',
  Respondent = 'Respondent',
}
